import React, { useContext, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import ContextComponent from "../../AppContext";
import Utils from "../../Utils";

import templatesImg from "../../../assets/img/navitems/dark/templates.png";
import templatesActiveImg from "../../../assets/img/navitems/light/templates.png";

import usersImg from "../../../assets/img/navitems/dark/users.png";
import usersActiveImg from "../../../assets/img/navitems/light/users.png";

import settingsImg from "../../../assets/img/navitems/dark/settings.png";
import settingsActiveImg from "../../../assets/img/navitems/light/settings.png";

import reportsImg from "../../../assets/img/navitems/dark/report.png";
import reportsActiveImg from "../../../assets/img/navitems/light/report.png";

import globalReportsImg from "../../../assets/img/navitems/dark/globalreports.png";
import globalReportsActiveImg from "../../../assets/img/navitems/light/globalreports.png";

import {
  ChevronDown,
  ChevronRight,
  Folder2,
  PencilSquare,
  PlusCircle,
  Trash3,
} from "react-bootstrap-icons";
import FolderActionsModal from "./folder.actions/FolderActionsModal";

const images = {
  sites: templatesImg,
  users: usersImg,
  settings: settingsImg,
  reports: reportsImg,
  globalReports: globalReportsImg,
};

const activeImages = {
  sites: templatesActiveImg,
  users: usersActiveImg,
  settings: settingsActiveImg,
  reports: reportsActiveImg,
  globalReports: globalReportsActiveImg,
};

const BASE_INDENT = 16;

const LeftNavigation = () => {
  let { userData, virtualFolderData } = useContext(ContextComponent);

  let navLinkKeys = Utils.NAV_ITEMS_KEYS;
  let navLinkValues = Utils.NAV_ITEMS_VALUES;

  const [filteredNavLinkKeys, setFilteredNavLinkKeys] = useState([]);
  const [expandedFolders, setExpandedFolders] = useState({});
  // const isAtRootUrl = location?.pathname === Utils.APP_URLS.LANDING_PAGE;
  const [activeModal, setActiveModal] = useState({
    type: null,
    projectId: null,
  });
  const [modaCanOpen, setModalCanOpen] = useState(false);

  let folderTree = virtualFolderData;
  const location = useLocation();

  useEffect(() => {
    if (Object.keys(userData).length) {
      const tempFilteredNavLinkKeys = [];
      navLinkKeys.forEach((navLinkKey) => {
        if (navLinkValues[navLinkKey].enabled) {
          tempFilteredNavLinkKeys.push(navLinkKey);
        } else {
          if (userData[navLinkValues[navLinkKey].persona]) {
            tempFilteredNavLinkKeys.push(navLinkKey);
          }
        }
      });
      setFilteredNavLinkKeys(tempFilteredNavLinkKeys);
    }
  }, [userData]);

  useEffect(() => {
    const activePath = location.pathname;

    const findPathToNode = (nodes, path = []) => {
      for (const node of nodes) {
        const fullPath = `${Utils.APP_URLS.PROJECTS_PAGE}/${node.id}`;
        if (fullPath === activePath) {
          return [...path, node.id];
        }
        if (node.children?.length) {
          const result = findPathToNode(node.children, [...path, node.id]);
          if (result) return result;
        }
      }
      return null;
    };

    const pathToActiveNode = findPathToNode(virtualFolderData);
    if (pathToActiveNode) {
      const expandedState = {};
      pathToActiveNode.forEach((id) => {
        expandedState[id] = true;
      });
      setExpandedFolders(expandedState);
    }
  }, [location.pathname, virtualFolderData]);

  const toggleFolder = (key) => {
    setExpandedFolders((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleFolderAction = (e, item) => {
    const actionType = e.currentTarget.dataset.action;
    e.preventDefault();
    e.stopPropagation();
    setModalCanOpen(true);
    setActiveModal({ type: actionType, item });
  };

  const NavItem = (items, level = 0) => {
    return (
      <div className="indi-nav-child-wrapper indi-navmenu-item">
        {items.map((item) => {
          const hasChildren = item.children.length > 0;
          const isExpanded = expandedFolders[item?.id];
          const fullPath = `${Utils.APP_URLS.PROJECTS_PAGE}/${item?.id}`;
          const paddingLeft = level * BASE_INDENT;

          return (
            <div key={item?.id} className={`indi-nav-child-item`}>
              <div
                className="indi-nav-child-header"
                role="button"
                key={item?.id}
                style={{ paddingLeft: `${paddingLeft}px` }}
              >
                <NavLink
                  to={fullPath}
                  className={({ isActive }) =>
                    isActive ? "indi-navmenu-active" : "indi-navmenu-inactive"
                  }
                  onClick={(e) => {
                    if (hasChildren) {
                      toggleFolder(item?.children?.id);
                    }
                  }}
                >
                  <div className="indi-folder-item-wrapper">
                    {hasChildren ? (
                      <span
                        className="indi-chevron-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          toggleFolder(item?.id);
                        }}
                      >
                        {isExpanded ? (
                          <ChevronDown className="indi-custom-chevron-icon" />
                        ) : (
                          <ChevronRight className="indi-custom-chevron-icon" />
                        )}
                      </span>
                    ) : (
                      <span className="indi-chevron-icon"></span>
                    )}
                    <span className="indi-folder-icon-wrapper">
                      {level === 0 && (
                        <span className="indi-folder-icon">
                          <Folder2 />
                        </span>
                      )}
                      <span className="indi-ml-1">{item.name}</span>
                    </span>
                  </div>
                  <div className="indi-nav-child-icon-wrapper">
                    <span
                      role="button"
                      className="indi-nav-child-icon"
                      data-action="add"
                      onClick={(e) => handleFolderAction(e, item)}
                    >
                      <PlusCircle />
                    </span>
                    {level > 0 && (
                      <>
                        <span
                          role="button"
                          className="indi-nav-child-icon"
                          data-action="delete"
                          onClick={(e) => handleFolderAction(e, item)}
                        >
                          <Trash3 />
                        </span>
                        <span
                          role="button"
                          className="indi-nav-child-icon"
                          data-action="edit"
                          onClick={(e) => handleFolderAction(e, item)}
                        >
                          <PencilSquare />
                        </span>
                      </>
                    )}
                  </div>
                </NavLink>
              </div>

              {hasChildren && isExpanded && NavItem(item?.children, level + 1)}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="indi-left-navigation-wrapper">
      {/* Render dynamic folders here */}
      {NavItem(folderTree)}

      {/* Render other nav items here */}
      {filteredNavLinkKeys.map((navKey, index) => (
        <div className="indi-navmenu-item" key={index}>
          <NavLink
            className={({ isActive }) =>
              isActive ? "indi-navmenu-active" : "indi-navmenu-inactive"
            }
            to={navLinkValues[navKey].url}
          >
            {({ isActive }) => (
              <>
                {isActive ? (
                  <img
                    className="indi-w-32 w-20"
                    src={activeImages[navKey]}
                    alt={navLinkValues[navKey].title}
                  />
                ) : (
                  <img
                    className="indi-w-32 w-20"
                    src={images[navKey]}
                    alt={navLinkValues[navKey].title}
                  />
                )}
                <span className="indi-ml-1">{navLinkValues[navKey].title}</span>
              </>
            )}
          </NavLink>
        </div>
      ))}

      {activeModal.type && (
        <FolderActionsModal
          modalType={activeModal.type}
          item={activeModal.item}
          modalCanOpen={modaCanOpen}
          setModalCanOpen={setModalCanOpen}
        />
      )}
    </div>
  );
};

export default LeftNavigation;
